import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function PreviousYearQuestionsChemTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="chemistry" type="previousyearquestions" />

    </>
  );
}

export default PreviousYearQuestionsChemTopics;